import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { SCHEMA_MODAL_HOST } from '@kros-sk/core/schema';

import { UrlModalsConfig } from './url-modal.types';
import { URL_MODALS_CONFIG, UrlModals } from './url-modals.service';
import { UrlSchemaModalHost } from './url-schema-modal-host';

/**
 * Switches URL modals on for this injector and everything below it. The engine starts at once, so the dev warning
 * for a link nobody declares also fires on a page that declares nothing. It also opens the modals schema nodes
 * declare under `modals`, through `SCHEMA_MODAL_HOST`.
 */
export function provideUrlModals(config: UrlModalsConfig = {}): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: URL_MODALS_CONFIG, useValue: config },
    UrlModals,
    { provide: SCHEMA_MODAL_HOST, useClass: UrlSchemaModalHost },
    provideEnvironmentInitializer(() => inject(UrlModals)),
  ]);
}
